module.exports = __webpack_public_path__ + "static/media/foto13.4594ffaf.png";